import * as d3 from "d3";
import * as topojson from "topojson-client";

export default {
  async mounted() {
    // 1. Setup Canvas and Dimensions
    const canvas = this.el;
    const context = canvas.getContext("2d");
    const width = canvas.width;
    const height = canvas.height;

    // 2. Define Geo Projection and Path Generator
    // Use an appropriate projection (e.g., geoAlbersUsa, geoMercator, geoOrthographic)
    const projection = d3.geoAlbersUsa().scale(1300).translate([487.5, 305]);

    // CRITICAL: Bind the canvas context to the path generator
    const pathGenerator = d3.geoPath().context(context);

    // 3. Load and Render TopoJSON Data
    const us = await d3.json(this.el.dataset.mapsrc);

    console.log(us);
    // Convert TopoJSON object to GeoJSON Feature Collection
    // Note: "countries" changes depending on the named object inside your specific file
    // const nation = topojson.feature(us, us.objects.nation);
    // const counties = topojson.feature(us, us.objects.counties);
    // const states = topojson.feature(us, us.objects.states);

    // Clear Canvas before painting
    context.clearRect(0, 0, width, height);
    context.lineJoin = "round";
    context.lineCap = "round";

    context.beginPath();
    pathGenerator(
      topojson.mesh(
        us,
        us.objects.counties,
        (a, b) => a !== b && ((a.id / 1000) | 0) === ((b.id / 1000) | 0),
      ),
    );
    context.lineWidth = 0.5;
    context.strokeStyle = "#aaa";
    context.stroke();

    context.beginPath();
    pathGenerator(topojson.mesh(us, us.objects.states, (a, b) => a !== b));
    context.lineWidth = 0.5;
    context.strokeStyle = "#000";
    context.stroke();

    context.beginPath();
    pathGenerator(topojson.feature(us, us.objects.nation));
    context.lineWidth = 1;
    context.strokeStyle = "#000";
    context.stroke();
    // let state = {
    //   clickedLocation: null
    // }

    // function handleClick(e) {
    //   let pos = pointer(e, this)
    //   state.clickedLocation = projection.invert(pos)
    //   update();
    // }

    // select('canvas')
    //   .on('click', handleClick);

    // function update() {
    //   context.clearRect(0, 0, 800, 400);

    //   geojson.features.forEach(function (d) {
    //     context.beginPath();
    //     context.fillStyle = state.clickedLocation && geoContains(d, state.clickedLocation) ? 'red' : '#aaa';
    //     geoGenerator(d);
    //     context.fill();
    //   })
    // }
  },
};
